import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { spacing40 } from 'approot/shared/styles/spacing.style';
import { grey5 } from 'approot/shared/styles/colours.style';
import { Box } from 'approot/shared/design-system/box/box.style';

export const AttemptContent = styled(Box).attrs({
  $marginBottom: 24,
})`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  padding: ${rem(100)} ${rem(spacing40)};
`;

export const AttemptNav = styled(Box).attrs({
  $gap: 4,
  $alignItems: 'center',
  $justifyContent: 'center',
})`
  position: relative;
  z-index: 1;
`;
